const allowedValueChars = "A-Za-z0-9,.:{} \"'\\[\\]\\\\!@#$%;&()\\-+=~`/|<>?^*_";

export const VendorDataRestictions = {
    allowedValueRegex: new RegExp(`^[${allowedValueChars}]*$`),
    deniedSymbolRegex: new RegExp(`[^${allowedValueChars}]`),
    maxValueLength: 2000,
    maxTitleLength: 64,
};

export enum VendorDataErrorMessages {
    ShouldNotBeEmpty = "Should not be empty",
    TitleIsDuplicated = "Title is duplicated",
    ValueContainsWrongSymbol = "Value contains wrong symbol:",
}
